"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteScheduleAction = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
const commands_1 = require("../commands");
const deleteScheduleAction = (scheduleId) => {
    const deleteCard = __1.CardHelper.newCard();
    deleteCard.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `Are you sure you want to delete this series?`,
        wrap: true,
        color: adaptivecards_1.TextColor.Attention,
    }));
    deleteCard.addAction(__1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: "Delete",
        data: (0, commands_1.scheduleDeleteCommand)({ scheduleId }).toTaskFetchCommand(),
    }));
    return __1.CardHelper.create(adaptivecards_1.ShowCardAction, {
        title: `Delete series`,
        card: deleteCard,
    });
};
exports.deleteScheduleAction = deleteScheduleAction;
//# sourceMappingURL=DeleteScheduleAction.js.map